import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from "@/components/ui/select";
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import type { Dispatch, SetStateAction } from "react";

export default function MonthYearPicker({
    month,
    setMonth,
}: {
    month: string;
    setMonth: Dispatch<SetStateAction<string>>;
}) {
    const [searchParams, setSearchParams] = useSearchParams();
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth();

    const getLastMonths = () => {
        const months = [];
        for (let i = 0; i < 10; i++) {
            const date = new Date(currentYear, currentMonth - i, 1);
            months.push({
                value: `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}`,
                label: date.toLocaleDateString("en-US", {
                    month: "long",
                    year: "numeric",
                }),
            });
        }
        return months;
    };

    const availableMonths = getLastMonths();

    // Initialize month from URL params or default to current month
    useEffect(() => {
        const monthParam = searchParams.get("month");
        if (monthParam) {
            setMonth(monthParam);
        } else if (!month) {
            // Set default month if none is set
            setMonth(availableMonths[0].value);
        }
    }, []);

    // Sync month changes to URL
    useEffect(() => {
        if (month) {
            const params = new URLSearchParams(searchParams);
            params.set("month", month);
            setSearchParams(params, { replace: true });
        }
    }, [month, setSearchParams]);

    return (
        <div className="mx-3 my-2">
            <Select
                value={month || availableMonths[0].value}
                onValueChange={(val) => setMonth(val)}
            >
                <SelectTrigger id="month-select">
                    <SelectValue placeholder="Select Month" />
                </SelectTrigger>
                <SelectContent>
                    {availableMonths.map((monthItem) => (
                        <SelectItem
                            key={monthItem.value}
                            value={monthItem.value}
                        >
                            {monthItem.label}
                        </SelectItem>
                    ))}
                </SelectContent>
            </Select>
        </div>
    );
}
